import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';
import { IntlService } from '@progress/kendo-angular-intl';
import {
    PerformanceScorecardService,
    ScorecardProductionWebModel,
    ScorecardPartnerWebModel,
    IScorecardParameters,
    IProductionPurposeMixPieChartData,
    ScorecardMixListWebModel,
    ScorecardMixWebModel,
    ScorecardType,
} from '../../services/performance-scorecard.service';
import { DisplayOptions } from '../../../shared/interfaces/display-options';
import { forkJoin } from 'rxjs';
import {
    NoDataTypes,
    NoDataActionType,
    NoDataSourceType,
} from '../../../shared/interfaces/no-data';
import {
    SmallCardData,
    IBottomCardData,
    ITableTdItems,
    IRowItems,
    ILargeCardInteriorOptions,
} from 'app/modules/shared/interfaces/card-data';
import { ICardlistData } from '../../../shared/components/card-list/card-list.component';
import {
    ScorecardKpicardDataHandler,
    IScorecardKpiParams,
} from '../../../shared/classes/scorecards-kpi-card-data-handler';
import { IPageHeadline } from '../../../shared/classes/page-title-parameters';
import { DomSanitizer } from '@angular/platform-browser';
import { IScorecardDetailsCardData } from '../../../shared/components/scorecards-score-summary-card/scorecards-score-summary-card.component';

@Component({
    selector: 'app-performance-scorecard-third-party',
    templateUrl: './performance-scorecard-third-party.component.html',
    styleUrls: ['./performance-scorecard-third-party.component.scss'],
})
export class PerformanceScorecardThirdPartyComponent implements OnInit {
    smallCards: SmallCardData[];
    bottomeCard: IBottomCardData[];
    tableData: ITableTdItems[];
    rowItems: IRowItems[];
    fromDatePeriod: string = '';
    partnerIdentifier: string;
    partnerIdentifierRoute: string;
    partnerList: ScorecardPartnerWebModel[];
    profilePicSrc: string;
    thirdPartyType = 'D';
    thirdPartyTypeUrl = null;
    pageTitleShort = null;
    pageTitle = null;
    ymc: string;
    cardDrilldownUrl: string = '/performance/scorecards';
    displayOptions: DisplayOptions[];
    partnerListSettings: any;
    selectedpartner: ScorecardPartnerWebModel[];
    noDataType: NoDataTypes;
    kpiCardData: ICardlistData;
    action: NoDataActionType;
    pageHeadline: IPageHeadline;
    scorecardProductionData: ScorecardProductionWebModel[];
    kpiTableColInfo: ITableTdItems[] = [
        {
            headerTitle: '',
            fieldId: 'weight',
            isHyperlinked: false,
            isIconColumn: true,
            iconClass: 'fas fa-weight-hanging',
            headerStyle: {
                'text-align': 'center',
                color: '#333333',
            },
            style: {
                'font-weight': '500',
                'text-align': 'center',
                'font-size': '12px',
                'padding-right': '8px',
                width: '3%',
            },
        },
        {
            headerTitle: 'KPI',
            fieldId: 'clientKPIMatrixDescription',
            isHyperlinked: false,
            headerStyle: {
                'text-align': 'left',
                color: '#333333',
            },
            style: {
                'font-weight': '500',
                'text-align': 'left',
                'font-size': '14px',
                width: '20%',
            },
        },
        {
            headerTitle: 'Target',
            fieldId: 'target',
            isHyperlinked: false,
            headerStyle: {
                'text-align': 'right',
                color: '#333333',
            },
            style: {
                'text-align': 'right',
                'font-size': '14px',
                width: '12%',
            },
        },
        {
            headerTitle: 'MTD',
            fieldId: 'monthlyValue',
            isHyperlinked: false,
            headerStyle: {
                'text-align': 'right',
                color: '#333333',
            },
            style: {
                'text-align': 'right',
                'font-size': '14px',
                width: '13%',
            },
        },
        {
            headerTitle: 'Prior MTD',
            fieldId: 'monthlyValue',
            isHyperlinked: false,
            headerStyle: {
                'text-align': 'right',
                color: '#333333',
            },
            style: {
                'text-align': 'right',
                'font-size': '14px',
                width: '14%',
            },
            showIndicator: true,
            compareFieldId: 'previousMonthlyValue',
            diffField: 'monthlyDiff',
        },
        {
            headerTitle: this.fromDatePeriod === '12m' ? '12mo' : 'YTD',
            fieldId: 'aggValue',
            isHyperlinked: false,
            headerStyle: {
                'text-align': 'right',
                color: '#333333',
            },
            style: {
                'text-align': 'right',
                'font-size': '14px',
                width: '14%',
            },
        },
        {
            headerTitle: this.fromDatePeriod === '12m' ? 'Prev 12mo' : 'Prev YTD',
            fieldId: 'aggValue',
            isHyperlinked: false,
            headerStyle: {
                'text-align': 'right',
                color: '#333333',
            },
            style: {
                'text-align': 'right',
                'font-size': '14px',
                width: '14%',
            },
            showIndicator: true,
            compareFieldId: 'previousAggValue',
            diffField: 'aggDiff',
        },
    ];

    productionPurposeMixPieChartData: IProductionPurposeMixPieChartData;
    pageId = 'performanceScorecardThirdParty';
    largeCardInteriorOptions: ILargeCardInteriorOptions;
    detailsCard: IScorecardDetailsCardData;

    constructor(
        private performanceScorecardService: PerformanceScorecardService,
        private route: ActivatedRoute,
        private _reusableFunctions: ReusableFunctions,
        private intl: IntlService,
        private _sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        scroll(0, 0);
        this.thirdPartyTypeUrl = this.route.snapshot.routeConfig.path;
        this.pageHeadline = {
            module: 'performance',
            moduleIcon: 'fa-heartbeat',
            moduleLink: 'performance/scorecards/',
            pageTitle: '',
            linkTitle: 'Performance Scorecards',
        };

        // TODO: add ae type
        switch (this.thirdPartyTypeUrl) {
            case 'scorecards/broker':
                this.thirdPartyType = 'K';
                this.pageTitleShort = 'Broker';
                this.pageTitle = 'Broker Scorecard';
                this.pageHeadline.pageTitle = 'Broker Scorecard';
                break;
            case 'scorecards/buyer-agent':
                this.thirdPartyType = 'B';
                this.pageTitleShort = 'Buyer Agent';
                this.pageTitle = 'Buyer Agent Scorecard';
                this.pageHeadline.pageTitle = 'Buyer Agent Scorecard';
                break;
            case 'scorecards/buyer-agency':
                this.thirdPartyType = 'BC';
                this.pageTitleShort = 'Buyer Agency';
                this.pageTitle = 'Buyer Agency Scorecard';
                this.pageHeadline.pageTitle = 'Buyer Agency Scorecard';
                break;
            case 'scorecards/settlement-agency':
                this.thirdPartyType = 'STC';
                this.pageTitleShort = 'Settlement Agency';
                this.pageTitle = 'Settlement Agency Scorecard';
                this.pageHeadline.pageTitle = 'Settlement Agency Scorecard';
                break;
            case 'scorecards/investor':
                this.thirdPartyType = 'I';
                this.pageTitleShort = 'Investor';
                this.pageTitle = 'Investor Scorecard';
                this.pageHeadline.pageTitle = 'Investor Scorecard';
                break;
            case 'scorecards/servicer':
                this.thirdPartyType = 'V';
                this.pageTitleShort = 'Servicer';
                this.pageTitle = 'Servicer Scorecard';
                this.pageHeadline.pageTitle = 'Servicer Scorecard';
                break;
            default:
                this.thirdPartyType = 'D';
                this.pageTitleShort = 'Lender';
                this.pageTitle = 'Lender Scorecard';
                this.pageHeadline.pageTitle = 'Lender Scorecard';
                break;
        }

        scroll(0, 0);
        this.action = NoDataActionType.pageStart;
        this.smallCards = [
            {
                urlSegment: '',
                title: 'Avg LA',
                routerLink: this.cardDrilldownUrl,
                isDataReady: false,
                hidePointer: true,
            },
            {
                urlSegment: '',
                title: 'Conv',
                routerLink: this.cardDrilldownUrl,
                isDataReady: false,
                hidePointer: true,
            },
            {
                urlSegment: '',
                title: 'Govt',
                routerLink: this.cardDrilldownUrl,
                isDataReady: false,
                hidePointer: true,
            },
            {
                urlSegment: '',
                title: 'Non-Conf',
                routerLink: this.cardDrilldownUrl,
                isDataReady: false,
                hidePointer: true,
            },
        ];

        this.noDataType = {
            action: NoDataActionType.emptySelect,
            searchTerm: this.pageTitleShort,
            componentTitle: 'Scorecard',
            inputSource: NoDataSourceType.largeDataCard,
            wrapInACard: true,
        };

        this.partnerListSettings = {
            singleSelection: true,
            text: `Select ${this.pageTitleShort}`,
            enableSearchFilter: true,
            showCheckbox: false,
            labelKey: 'partnerName',
            primaryKey: 'partnerIdentifier',
            enableFilterSelectAll: false,
        };

        this.displayOptions = this._reusableFunctions.getCurrentDisplayOptions(
            `/performance/${this.thirdPartyTypeUrl}`
        );

        this.productionPurposeMixPieChartData =
            this.performanceScorecardService.initializeDonutcharts();
        this.largeCardInteriorOptions = this.performanceScorecardService.initializeProductionChart(
            this.pageId,
            this.action
        );
        this.setDisplayOptionsSelected();
        this.lopartnerDisplayOptionsInit();
    }

    populateSmallCardData(data: ScorecardMixListWebModel, action: NoDataActionType = null) {
        let avgLoan = 0;

        let unitsFunded: number;
        let volFunded: number;
        let allFunded: ScorecardMixWebModel[] = [];
        let allLocked: ScorecardMixWebModel[] = [];

        if (data?.pieDataMixList?.length > 0) {
            unitsFunded = data.pieDataMixList
                .filter((x) => x.category === 'Funded')
                .reduce((unitsFunded, item) => unitsFunded + item.units, 0);
            volFunded = data.pieDataMixList
                .filter((x) => x.category === 'Funded')
                .reduce((volFunded, item) => volFunded + item.volume, 0);
            allFunded = data.pieDataMixList.filter((x) => x.category === 'Funded');
            allLocked = data.pieDataMixList.filter((x) => x.category === 'Locked');
        }

        const conVolFunded = allFunded
            .filter((x) => x.loanTypeCategory.toUpperCase() === 'CONV')
            .reduce((conVolFunded, item) => conVolFunded + item.volume, 0);

        const govVolFunded = allFunded
            .filter((x) => x.loanTypeCategory.toUpperCase() === 'GOVT')
            .reduce((govVolFunded, item) => govVolFunded + item.volume, 0);
        const otherVolFunded = allFunded
            .filter((x) => x.loanTypeCategory === 'Other')
            .reduce((otherVolFunded, item) => otherVolFunded + item.volume, 0);

        const conVolLocked = allLocked
            .filter((x) => x.loanTypeCategory.toUpperCase() === 'CONV')
            .reduce((conVolLocked, item) => conVolLocked + item.volume, 0);
        const govVolLocked = allLocked
            .filter((x) => x.loanTypeCategory.toUpperCase() === 'GOVT')
            .reduce((govVolLocked, item) => govVolLocked + item.volume, 0);
        const otherVolLocked = allLocked
            .filter((x) => x.loanTypeCategory === 'Other')
            .reduce((otherVolLocked, item) => otherVolLocked + item.volume, 0);

        if (unitsFunded > 0) {
            avgLoan = volFunded / unitsFunded;
        }

        this.smallCards.forEach((card) => {
            if (card.title === 'Avg LA') {
                card.mainValue = this.intl.formatNumber(avgLoan, 'c0');
            } else if (card.title === 'Conv') {
                card.bottomCardData = [
                    {
                        value: 'Funded',
                        description: this.intl.formatNumber(conVolFunded, 'c0'),
                        hasAccess: true,
                    },
                    {
                        value: 'Locked',
                        description: this.intl.formatNumber(conVolLocked, 'c0'),
                        hasAccess: true,
                    },
                ];
            } else if (card.title === 'Govt') {
                card.bottomCardData = [
                    {
                        value: 'Funded',
                        description: this.intl.formatNumber(govVolFunded, 'c0'),
                        hasAccess: true,
                    },
                    {
                        value: 'Locked',
                        description: this.intl.formatNumber(govVolLocked, 'c0'),
                        hasAccess: true,
                    },
                ];
            } else if (card.title === 'Non-Conf') {
                card.bottomCardData = [
                    {
                        value: 'Funded',
                        description: this.intl.formatNumber(otherVolFunded, 'c0'),
                        hasAccess: true,
                    },
                    {
                        value: 'Locked',
                        description: this.intl.formatNumber(otherVolLocked, 'c0'),
                        hasAccess: true,
                    },
                ];
            }
            card.isDataReady = true;
            card = Object.assign({}, card);
        });
    }

    // DISPLAY OPTIONS /////////////////////////////
    setDisplayOptionsSelected() {
        if (this.displayOptions.find((item) => item.optionKey === 'dateRangeRolling')) {
            this.fromDatePeriod = this.displayOptions.find(
                (item) => item.optionKey === 'dateRangeRolling'
            ).selectedOptions;
        }
        if (this.displayOptions.find((item) => item.optionKey === 'scorecardAsOf')) {
            this.ymc = this.displayOptions.find(
                (item) => item.optionKey === 'scorecardAsOf'
            ).selectedOptions;
        }
    }

    loadData() {
        this.kpiInit();
        if (this.partnerIdentifier) {
            this.setPartnerDetails();
            this.setFundedProduction();
            this.productPurposeMixCardInit();
        }
    }

    lopartnerDisplayOptionsInit(split = false) {
        this.performanceScorecardService
            .getScorecardPartnerList(this.thirdPartyType, this.fromDatePeriod, this.ymc)
            .subscribe(
                (res) => {
                    let hasSelectedEntity = false;
                    this.partnerList = res;
                    if (this.partnerList && this.partnerList.length > 0) {
                        this.partnerList = this.partnerList.filter((e) => e.partnerName);

                        if (this.selectedpartner && this.selectedpartner.length > 0) {
                            hasSelectedEntity = this._reusableFunctions.hasTheGivenObjectIntheArray(
                                this.selectedpartner[0],
                                this.partnerList,
                                'partnerIdentifier'
                            );
                        }
                    }

                    if (hasSelectedEntity) {
                        this.loadData();
                    } else {
                        this.selectedpartner = [];
                    }
                },
                (error) => {
                    this.noDataType.action = NoDataActionType.error;
                    this.noDataType.searchTerm = '';
                    this.noDataType.componentTitle = `${this.pageTitleShort} Scorecard`;
                }
            );
    }

    // LO DETAILS //////////////////////////////////
    setPartnerDetails() {
        let scorecardParameters = this.getParameters();
        scorecardParameters.chartGroup = 'product';
        this.detailsCard = this.performanceScorecardService.initializeScoreDetailsCard(
            ScorecardType.thirdParty,
            this.action
        );

        forkJoin(
            this.performanceScorecardService.getScoreDetails(scorecardParameters),
            this.performanceScorecardService.getPositionMix(scorecardParameters)
        ).subscribe(
            ([lenderDetails, smallCardData]) => {
                if (lenderDetails && lenderDetails !== null) {
                    if (smallCardData && smallCardData !== null) {
                        this.populateSmallCardData(smallCardData);
                        this.detailsCard.bottomCards = this.smallCards;
                    }

                    this.detailsCard = this.performanceScorecardService.updateScoreDetails(
                        this.detailsCard,
                        lenderDetails
                    );
                } else {
                    this.detailsCard.hasData = false;
                    this.detailsCard.isDataLoading = false;
                    this.detailsCard = Object.assign({}, this.detailsCard);
                }
            },
            (error) => {
                this.detailsCard.action = NoDataActionType.error;
                this.detailsCard.hasData = false;
                this.detailsCard.isDataLoading = false;
                this.detailsCard = Object.assign({}, this.detailsCard);
            }
        );
    }

    getParameters() {
        let scorecardParameters: IScorecardParameters = {
            scoreCardType: ScorecardType.thirdParty,
            entityIdentifier: this.partnerIdentifier,
            entityType: this.thirdPartyType,
            fromDatePeriod: this.fromDatePeriod,
            ymc: this.ymc,
            chartGroup: '',
        };
        return Object.assign({}, scorecardParameters);
    }

    // FUNDED PRODUCTION ///////////////////////////
    setFundedProduction() {
        let chartTitle = this.pageTitleShort + ' Production';
        this.largeCardInteriorOptions = this.performanceScorecardService.initializeProductionChart(
            this.pageId,
            this.action
        );
        this.performanceScorecardService.getProductionData(this.getParameters()).subscribe(
            (res: ScorecardProductionWebModel[]) => {
                this.largeCardInteriorOptions =
                    this.performanceScorecardService.drawFundedProductionChart(
                        res,
                        this.largeCardInteriorOptions,
                        chartTitle
                    );
            },
            (error) => {
                this.largeCardInteriorOptions.hasData = true;
                this.largeCardInteriorOptions.isDataReady = true;
                this.largeCardInteriorOptions.action = NoDataActionType.error;
                this.largeCardInteriorOptions =
                    this.performanceScorecardService.drawFundedProductionChart(
                        undefined,
                        this.largeCardInteriorOptions,
                        chartTitle
                    );
                throw new Error(error);
            }
        );
    }

    onSelectionChange(event) {
        this.action = NoDataActionType.filter;
        this.partnerIdentifier = this.selectedpartner[0].partnerIdentifier;
        this.loadData();
    }

    onItemDeSelect(event) {
        this.selectedpartner = [event];
    }

    // KPI /////////////////////////////////////////
    kpiInit() {
        let kpiDataHandler = new ScorecardKpicardDataHandler(
            this._reusableFunctions,
            this._sanitizer
        );
        let params: IScorecardKpiParams = {
            cardId: 'performanceLenderScoreCardKpi',
            title: 'Key Performance Indicators',
            data: [],
            action: this.action,
            searchTerm: '', // TODO; Set these values
            cardDrilldownUrl: '', // TODO; Set these values
            styleSet: { 'cardlist-container-area': { height: '440px' } },
            isDataReady: this.partnerIdentifier ? false : true,
        };
        this.kpiCardData = kpiDataHandler.initializeCards(params);
        if (this.partnerIdentifier) {
            this.performanceScorecardService
                .getPartnerKpi(
                    this.thirdPartyType,
                    this.partnerIdentifier,
                    this.fromDatePeriod,
                    this.ymc
                )
                .subscribe(
                    (res) => {
                        this.kpiCardData = kpiDataHandler.handleKPILargeCards(
                            this.kpiCardData,
                            res,
                            this.fromDatePeriod,
                            this.kpiTableColInfo
                        );
                    },
                    () => {
                        params.action = NoDataActionType.error;
                        params.isDataReady = true;
                        this.kpiCardData = kpiDataHandler.initializeCards(params);
                    }
                );
        }
    }

    // PRODUCT MIX /////////////////////////////////
    productPurposeMixCardInit() {
        this.productionPurposeMixPieChartData =
            this.performanceScorecardService.initializeDonutcharts();
        this.productionPurposeMixPieChartData.noDataType.action = this.action;
        let scorecardParameters = this.getParameters();
        let chartGroups = ['Product', 'Purpose'];

        chartGroups.forEach((chartGroup) => {
            scorecardParameters.chartGroup = chartGroup.toLowerCase();
            this.performanceScorecardService.getPositionMix(scorecardParameters).subscribe(
                (res) => {
                    this.productionPurposeMixPieChartData =
                        this.performanceScorecardService.productPurposeMixCardLoad(
                            res,
                            this.productionPurposeMixPieChartData,
                            chartGroup
                        );
                },
                (error) => {
                    this.productionPurposeMixPieChartData['isLoading' + chartGroup + 'Mix'] = false;
                    this.productionPurposeMixPieChartData.noDataType.action =
                        NoDataActionType.error;
                    this.productionPurposeMixPieChartData =
                        this.performanceScorecardService.productPurposeMixCardLoad(
                            null,
                            this.productionPurposeMixPieChartData,
                            chartGroup
                        );
                }
            );
        });
    }

    applyDisplayOptions(event: DisplayOptions[]) {
        this.action = NoDataActionType.filter;
        this.displayOptions = event;
        this.setDisplayOptionsSelected();
        this.lopartnerDisplayOptionsInit();
    }
}
